export const OSM_LABEL = 'OpenStreetMap';
export const OSM_URL = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';
export const OSM_ATTRIBUTION = '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>';

export const MARKER_DATA_KEY = 'plan';
export const HOTSPOT_GENERATED_ID = '__generated__';
export const HOTSPOT_MARKER_ID = '__marker__';
